import React from 'react';
import {Text, TouchableOpacity} from 'react-native';
import {BUTTON_TYPES} from '../../../utils/Constants';
import {tID} from '../../../utils/TestIdHelper';
import {useTheme, useThemedStyles} from '../../../theme';
import makeStyles from './styles';

export default function Button({
  style = {},
  titleStyle = {},
  buttonType = BUTTON_TYPES.Bordered,
  onPress,
  title,
  titleColor,
  topMargin = 0,
  disabled,
  disabledColor,
  testID = '',
}) {
  // Themed DEFAULTS only (legacy mainLargeText → link, grey3 → textDisabled;
  // identical in light). Explicit titleColor/disabledColor props still win.
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  const resolvedTitleColor =
    titleColor === undefined ? colors.link : titleColor;
  const resolvedDisabledColor =
    disabledColor === undefined ? colors.textDisabled : disabledColor;

  let buttonStyle = [styles.borderedButton, style];

  if (buttonType === BUTTON_TYPES.Plain) {
    buttonStyle = [style];
  } else if (buttonType == BUTTON_TYPES.Filled) {
    buttonStyle = [styles.filledButton, style];
  }

  if (disabled && buttonType === BUTTON_TYPES.Filled) {
    buttonStyle = [buttonStyle, {backgroundColor: resolvedDisabledColor}];
  } else if (disabled && buttonType === BUTTON_TYPES.Bordered) {
    buttonStyle = [
      buttonStyle,
      {borderColor: resolvedDisabledColor},
      styles.op07,
    ];
  }

  return (
    <TouchableOpacity
      disabled={disabled}
      accessibilityRole="button"
      accessibilityState={{disabled: !!disabled}}
      style={[{marginTop: topMargin}, buttonStyle]}
      testID={testID}
      onPress={onPress}
    >
      <Text
        testID={tID('Button-Text-Title')}
        style={[styles.titleStyle, {color: resolvedTitleColor}, titleStyle]}
        maxFontSizeMultiplier={1.2}
        numberOfLines={1}
      >
        {title}
      </Text>
    </TouchableOpacity>
  );
}
